import React from "react";
import {Button} from "@reside/ui";

import {useResidentLoginModalContext} from "../../resident-login-modal";
import {Tooltip} from "../../../../tooltip";
import {getResidentTestId} from "../../../helper";
import {AdmissionFromSearch} from "../../../../../services/AdmissionsService";

const useStartResidentExperienceAction = (admission: AdmissionFromSearch) => {
  const {openModal} = useResidentLoginModalContext();
  const onStart = () => {
    openModal(admission);
  };
  const testId = getResidentTestId(admission, "residentLogin");
  return {onStart, testId};
};

export const StartResidentExperienceFooterButton = ({
  admission,
}: {
  admission: AdmissionFromSearch;
}) => {
  const {onStart, testId} = useStartResidentExperienceAction(admission);

  return (
    <Tooltip content="Start Resident Experience">
      <Button
        size="small"
        color="primary"
        outline
        flat
        onClick={onStart}
        testId={testId}
      >
        Start
      </Button>
    </Tooltip>
  );
};
